export default {
  banking: {
    title: 'We help companies build amazing',
    titleUnderline: 'digital products',
    phone: '+1 (617)-1231231-0956',
    button: 'GET IN TOUCH 123123123',

    companies: [
      {
        imageSrc: 'vorwerk.png',
        imageSrcset: 'vorwerk.png, vorwerk@2x.png 2x, vorwerk@3x.png 3x'
      },
      {
        imageSrc: 'edp.png',
        imageSrcset: 'edp.png, edp@2x.png 2x, edp@3x.png 3x'
      },
      {
        imageSrc: 'vorwerk.png',
        imageSrcset: 'vorwerk.png, vorwerk@2x.png 2x, vorwerk@3x.png 3x'
      },
      {
        imageSrc: 'edp.png',
        imageSrcset: 'edp.png, edp@2x.png 2x, edp@3x.png 3x'
      }
    ],

    testimonials: [
      {
        imageSrc: 'vorwerk.png',
        imageSrcset: 'vorwerk.png, vorwerk@2x.png 2x, vorwerk@3x.png 3x',
        author: 'AARRON WALTER, SAILS DIRECTO AT VORWERK',
        content: 'Curabitur mattis nec risus in faucibus. Aliquam sit amet metus nec sapien int at at libero.'
      },
      {
        imageSrc: 'vorwerk.png',
        imageSrcset: 'vorwerk.png, vorwerk@2x.png 2x, vorwerk@3x.png 3x',
        author: 'AARRON WALTER, SAILS DIRECTO AT VORWERK',
        content: 'Curabitur mattis nec risus in faucibus. Aliquam sit amet metus nec sapien int at at libero.'
      }
    ]
  }
};



// WEBPACK FOOTER //
// static/campaigns/campaigns.js